<script lang="ts" setup>
import { ElNotification } from 'element-plus'
import { reactive, ref } from 'vue'

import { useUpdateCampaignParticipant } from '@/api/campaignParticipant.api'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent/TypographyComponent.vue'

const props = defineProps<{
  campaignId: number
  participantId: string | number
  todo: { key: string; value: boolean }[]
  onChange: (items: { key: string; value: boolean }[]) => void
}>()

const { updateTodoList } = useUpdateCampaignParticipant(props.campaignId)

const isTodoFormDirty = ref(false)
const todoFormData = reactive<{ todo: { key: string; value: boolean }[] }>({
  todo: props.todo.map((item) => ({ ...item })),
})
const handleTodoSubmit = async () => {
  isTodoFormDirty.value = false
  await updateTodoList(props.participantId, todoFormData.todo)
  props.onChange(todoFormData.todo)
  ElNotification.success('To-do list was successfully changed.')
}
const resetTodoForm = () => {
  todoFormData.todo = props.todo.map((item) => ({ ...item }))
  isTodoFormDirty.value = false
}
</script>
<template>
  <el-form :model="todoFormData" @change="isTodoFormDirty = true" @submit.prevent="handleTodoSubmit">
    <FlexComponent direction="column" :gap="16">
      <TypographyComponent variant="headline-small">To do list</TypographyComponent>
      <el-checkbox v-for="(item, index) in todoFormData.todo" :key="index" v-model="item.value" :label="item.key" size="large">
        <TypographyComponent :is="item.value ? 's' : 'p'" variant="body-medium" color="#252423">
          {{ item.key }}
        </TypographyComponent>
      </el-checkbox>
      <FlexComponent v-if="isTodoFormDirty" :gap="8">
        <ButtonComponent variant="accent" type="submit">Save</ButtonComponent>
        <el-button round @click="resetTodoForm">Cancel</el-button>
      </FlexComponent>
    </FlexComponent>
  </el-form>
</template>
<style scoped></style>
